const $ = jQuery.noConflict();

class NavSlider {
    constructor(sel, arrow) {
        this.selector = sel;
        this.arrow = arrow;
    }
    init() {
        const mobileViewport = window.matchMedia('screen and (max-width: 767px)');
        const that = this;
        if(mobileViewport.matches) {
            that.slickify(); 
            $(that.arrow).on('click', () => {
                $(that.selector).slick('slickNext');
            });
        }
        mobileViewport.addListener((mV) => {
            if(mV.matches) {
                that.slickify();
                $(that.arrow).on('click', () => {
                    $(that.selector).slick('slickNext');
                });
            }
            else {
                $(that.selector).slick('unslick');
            }
        });
    }
    slickify() {

        $(this.selector).slick({
            dots: false,
            arrows: false,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 600,
        });
        this.setNavItemsHeight();
    }
    setNavItemsHeight() {
       
        // let maxHeight = -1;
        // $(this.selector).find('.slick-slide').each(function() {
        //   if ($(this).height() > maxHeight) {
        //     maxHeight = $(this).height();
        //     console.log($(this).height());
        //   }
        // });
        // $(this.selector).find('.slick-slide').each(function() {
        //   if ($(this).height() < maxHeight) {
        //     $(this).css('height', maxHeight + 'px');
            
        //   }
        // });
        
    }
}
const navSlider = new NavSlider('.scroll-nav-list', '.nav-arrow');

export default navSlider;
